/**
 * On page load
 **/
$(document).ready( function(){
	MobileNav();
	SecondaryNav();

	var mobile_main_title = '';
	if( jQuery('body').hasClass('theme-red') ||
		jQuery('body').hasClass('theme-green') ||
		jQuery('body').hasClass('theme-avocado') ||
		jQuery('body').hasClass('theme-teal') ||
		jQuery('body').hasClass('theme-blue') ||
		jQuery('body').hasClass('theme-text-grey') ) {

		var parent_main_menu = [ 'Guidance', 'Exemptions', 'Transactions', 'Governance', 'Law Reform', 'About the Panel' ];

		if( jQuery.trim(jQuery('div.banner-title h2.white-text.upper-text').text()) == '') {
			mobile_main_title = jQuery.trim( jQuery('div.banner-title h1.white-text').text() );
		} else {
			mobile_main_title = jQuery.trim( jQuery('div.banner-title h2.white-text.upper-text').text() );
		}

		if( parent_main_menu.includes( mobile_main_title ) ) {
			mobile_main_title = mobile_main_title + ' Menu';
		}

		$('body div.left.sidebar').prepend('<a class="mobile-menu-toggle" href="#">' + mobile_main_title + ' <span class="fa fa-angle-up"></span></a>');
		$('body div.left.sidebar').on('click', 'a.mobile-menu-toggle', function(a) {
			a.preventDefault();
			$(this).parent().toggleClass('open');
			if( $(this).parent().hasClass('open') ) {
				$(this).find('span.fa').addClass('fa-angle-down');
				$(this).find('span.fa').removeClass('fa-angle-up');
			} else {
				$(this).find('span.fa').removeClass('fa-angle-down');
				$(this).find('span.fa').addClass('fa-angle-up');
			}
		});

	}

});

function MobileNav(){
	$('.hamburglar').click( function(){
		$(this).toggleClass('open');
		$('.mainnav').toggleClass('open');
	});
}

/**
 * Because the secondary nav loads the entire site tree on page load
 * (all ten thousand billion pages), we have to cach the secondary nav template,
 * which means we have to commit the terrible crime
 * of using js to handle active states for nav items/sections. Sorry.
 */
function SecondaryNav(){

	// get the stuff we need
	var wrapper = $('.nav-secondary');
	var menu_item = wrapper.find('.menu-item');

	// first up, remove any classes already applied (and held in a choke-hold by caching)
	menu_item.removeClass('current section');

	// now, find out which nav link is the current one
	// and apply css-classes relative to it
	var current_link = $('.nav-link[href="' + window.location.pathname + '"]');
	current_link.parents('.menu-item').addClass('section');
	current_link.parent('.menu-item').addClass('current');

}


var yourNavigation = $(".sticky-nav"),
stickyDiv = "sticky",
yourHeader = $('.head').height();

$(window).scroll(function() {
	if( $(this).scrollTop() > yourHeader ) {
		yourNavigation.addClass(stickyDiv);
	}
	else {
		yourNavigation.removeClass(stickyDiv);
	}
});


// WEBPACK FOOTER //
// ./site/js/components/navigation.js